<template>
  <div class="about">
    <h1>ABOUT / SETTINGS</h1>
    <div class="about-grid">
      <div class="main-info">
        <h3 class="text-background">About</h3>
        <div class="info-content">
          <p>
            Test quickly an api.
            VAPI is made with <a href="https://vuejs.org">VueJS</a> and use axios to fetch the API.
            Hosted on <a href="https://www.netlify.com">netlify</a>
            You can find the source code on gitlab 🦊
            <a href="https://gitlab.com/mocatz/vapi">VAPI project</a>.
            <br/>⚠️ Actually in devellopment.
          </p>
          <p>
            You can also install VAPI on your device if you see the install button below.
            Otherwize try an other browser (works on chromium based browser)</p>
          <BtnAddToHomeScreen />
        </div>
      </div>
      <UserSettings />
    </div>
  </div>
</template>

<script>
import UserSettings from '../components/UserSettings.vue';
import BtnAddToHomeScreen from '../components/BtnAddToHomeScreen.vue';

export default {
  name: 'About',
  components: {
    BtnAddToHomeScreen,
    UserSettings,
  },
};
</script>

<style scoped>
  .about-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--unit-4);
  }

  .info-content {
    text-align: left;
    padding: 0 var(--unit-2);
  }

  @media (max-width: 700px) {
    .about-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
